function createGraphProductBreadcrumb(categoryBreadcrumb, productName, brandName) {
    let name = productName;
    if (!!brandName) {
        // if the product name already includes the brand name, strip it out
        // the brandName is used in a separate breadcrumb and shouldn't show up twice
        name = productName.replace(brandName, '').trim();
    }
    return productName && categoryBreadcrumb ? {
        name
    } : null;
}

export { createGraphProductBreadcrumb };
//# sourceMappingURL=create-graph-product-breadcrumb.js.map
